export default "__VITE_ASSET__fdd65a3b__"